let nextJobId = 1

export default function getNextWebWorkerJobId() {
  return nextJobId++
}
